import { useCallback } from 'react'
import { Button } from '@/ui'
import { fetchBillingPortalSession } from '@/actions/settings/billingActions'
import { useAppDispatch } from '@/utils/typeHelpers'

export const BillingPortalLink = (): JSX.Element => {
  const dispatch = useAppDispatch()

  const redirectToPortal = useCallback(async () => {
    const res = await fetchBillingPortalSession()(dispatch)

    if (res) {
      window.location.href = res.url
    }
  }, [dispatch])

  return (
    <Button variant="link" onClick={redirectToPortal}>
      the billing portal
    </Button>
  )
}
